import { formatNumber } from "@/apps/credit-line/helpers/formatNumber.helper";

/**
 * Calculates the effective annual interest rate from a nominal annual rate (as a decimal).
 * Returns a string rounded to 4 decimals using the shared formatNumber helper.
 *
 * @param annualRate - The nominal annual interest rate as a decimal (e.g., 0.25 for 25%)
 * @returns string - The effective annual interest rate, rounded to 4 decimals (e.g., "0.2839" for 28.39%)
 */
export function calculateEffectiveInterestRate(annualRate: number): string {
  const parsedAnnualRate = Number(annualRate);
  if (annualRate === null || annualRate === undefined || isNaN(annualRate)) return "NaN";
  if (isNaN(parsedAnnualRate)) return "NaN";
  const effectiveRate = Math.pow(1 + (parsedAnnualRate / 365), 365) - 1;
  return formatNumber(effectiveRate, 4);
}
